module.exports = "<p>\n  static-about works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/src/app/static-about/static-about.component.html
// module id = ../../../../../src/app/static-about/static-about.component.html
// module chunks = 0